var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 25.0005V19.1405C25 16.2605 24.38 14.0605 21.02 14.0605C19.4 14.0605 18.32 14.9405 17.88 15.7805H17.84V14.3205H14.66V25.0005H17.98V19.7005C17.98 18.3005 18.24 16.9605 19.96 16.9605C21.66 16.9605 21.68 18.5405 21.68 19.7805V24.9805H25V25.0005Z",
    fill: "#0E76A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26001 14.3203H12.58V25.0003H9.26001V14.3203Z",
    fill: "#0E76A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.92 9C9.86 9 9 9.86 9 10.92C9 11.98 9.86 12.86 10.92 12.86C11.98 12.86 12.84 11.98 12.84 10.92C12.84 9.86 11.98 9 10.92 9Z",
    fill: "#0E76A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.3e9feb412301dc180d0f1f39115c2c98.svg";
export { ForwardRef as ReactComponent };